import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { stepControlsContextObj, useFormContext } from '@cian/frontend-request-form-widget';
import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFormLayoutModal } from '../../selectors/formLayoutModal';
import { saveAndCloseFormLayoutModal } from '../../actions/formLayoutModal';
import { QuestionFooterContainer } from '../QuestionFooterContainer';
import { useFormTitle } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export var FormLayoutModalContainer = function FormLayoutModalContainer(_ref) {
  var children = _ref.children;
  var dispatch = useDispatch();
  var modalState = useSelector(selectFormLayoutModal);
  var _React$useContext = React.useContext(stepControlsContextObj),
    currentStep = _React$useContext.currentStep;
  var _useFormContext = useFormContext(),
    values = _useFormContext.values;
  var title = useFormTitle();
  var handleClose = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return dispatch(saveAndCloseFormLayoutModal(values));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [dispatch, values]);
  return /*#__PURE__*/_jsx(ModalWindow, {
    title: title,
    footer: /*#__PURE__*/_jsx(QuestionFooterContainer, {
      question: currentStep.question
    }),
    open: modalState.open,
    fixed: true,
    outside: true,
    maxWidth: 540,
    width: "100%",
    size: "M",
    onClose: handleClose,
    children: children
  });
};